<template>
  <div id="contactView">
    <mu-row>
      <mu-col desktop="33" tablet="0" width="0"></mu-col>
      <mu-col desktop="33" tablet="100" width="100">
        <mu-card id="contactForm">
          <mu-card-header :title="isHcpView ? 'Further Information and Feedback' : $t('message.contactTitle')"
                          titleClass="largeTitle boldTitle"></mu-card-header>
          <mu-card-text>
            <reset-account v-if="!isHcpView"></reset-account>
            <br/>
            <form @submit.prevent="submitMessage">
              <div class="form-row">
                <div class="title" v-text="isHcpView ? 'Subject' : $t('message.contactSubTitle')"></div>
                <div class="radio-group">
                  <div class="radio-item" v-for="option, index in options">
                    <mu-radio
                      class="radio"
                      :label="option.label"
                      :nativeValue="option.key"
                      v-model="messageModel.platform"
                      :key="'platformOption-' + index"
                    />
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="mainTitle" v-text="isHcpView ? 'Your message' : $t('message.contactBodyLabel')"></div>
                <mu-text-field
                  :hintText="isHcpView ? 'Enter your message here' : $t('message.placeholderText')"
                  multiLine
                  :rows="5"
                  :rowsMax="6"
                  fullWidth
                  v-model="messageModel.message"
                  v-validate
                  :data-vv-rules="'required'"
                  data-vv-name="message"
                  data-vv-value-path="inputValue"
                  :data-vv-as="$t('message.contactBodyLabel')"
                  data-vv-validate-on="none"
                  :errorText="errors.first('message')"/>
              </div>
              <button type="submit" style="display: none"/>

              <vue-recaptcha
                sitekey="6Lf_8LsUAAAAAPqMvImMQATwGHVXXM_Ke1oNLi-T"
                ref="invisibleRecaptcha"
                @verify="onVerify"
                size="invisible">
              </vue-recaptcha>

              <mu-raised-button
                class="submit"
                @click.native="submitMessage"
                type="button"
                :disabled="isSending"
                :label="isSending ? $t('message.sendingText') : isHcpView ? 'Send' : $t('message.submitText')"
                fullWidth/>
            </form>
          </mu-card-text>
        </mu-card>
      </mu-col>
      <mu-col desktop="33" tablet="0" width="0"></mu-col>
    </mu-row>
  </div>
</template>
<script>

  import config from '../../config';
  import ContactApi from '../../api/Contact/index';

  import './Contact.less';
  import ResetAccount from "../../components/ResetAccount/ResetAccount";
  import HCPMixin from '../../mixins/HCPMixin';
  import TitleManager from '../../helpers/TitleManager';
  import VueRecaptcha from 'vue-recaptcha'

  export default {
    mixins: [
      HCPMixin
    ],
    components: {ResetAccount, VueRecaptcha},
    name: 'contact',
    watch: {
      "$route": function () {
        let self = this;
        self.initMounted();
      }
    },
    data() {
      return {
        isSending: false,
        options: [
          {key: "APP", label: this.$t('message.contactReasonApp')},
          {key: "WEB", label: this.$t('message.contactReasonWebsite')},
          {key: "TECHNICAL", label: this.$t('message.contactReasonTechnical')},
          {key: 'FEATURE_REQUEST', label: this.$t('message.contactReasonFeatureRequest')},
          {key: 'OTHER', label: this.$t('message.contactReasonOther')}
        ],
        messageModel: {
          platform: "WEB",
          message: "",
          rtoken: null
        }
      }
    },
    methods: {
      submitMessage() {
        let self = this;
        if (this.messageModel.message === "") {
          self.$toastr.error('Please enter a message');
          return;
        }
        this.$refs.invisibleRecaptcha.execute();
      },
      onVerify(token) {
        let self = this;
        self.messageModel.rtoken = token;
        self.$validator.validateAll().then((valid) => {
          if (valid === true) {
            self.isSending = true;
            ContactApi.postMessage(self.messageModel).then(() => {
              self.$toastr.success(self.$t('message.contactAdded'));
              self.$router.push({name: 'Dashboard'});
            }).catch(() => {
              self.isSending = false;
              self.$toastr.error(self.$t('message.labelError'));
            });
          }
        })
      },
      initMounted() {
        let self = this;
        if (self.isHcpView) {
          TitleManager.replaceTitle('Feedback');
          self.options = [
            {key: "HCP_COMMISSION", label: self.$t('message.contactReasonHcpCommission')},
            {key: "HCP_TRAINING", label: self.$t('message.contactReasonHcpTraining')},
            {key: "HCP_LEAFLETS_FLYERS", label: self.$t('message.contactReasonHcpLeaflets')},
            {key: "HCP_SUGGESTIONS", label: "Platform development suggestions"},
            {key: "HCP_FEEDBACK", label: "Feedback"},
            {key: 'OTHER', label: this.$t('message.contactReasonOther')}
          ];
        }
        if (self.$route.query.commission) {
          self.messageModel.platform = "HCP_COMMISSION";
        }
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>



// WEBPACK FOOTER //
// Contact.vue?6dac08fc